<template>
  <div class="auth-page-body">
    <div :class="['container-wrapper', { active: isActive }]" id="containerWrapper">
      <div class="form-panel sign-in-panel text-center" v-if="ShowModalForget == false">
        <h4 class="text-dark mb-5 fw-bold">ورود به حساب کاربری</h4>
        <!-- <h4 class="text-center mobile-switch mt-3 mb-5 fw-bold" v-if="CustomerName!=null">{{ CustomerName }}</h4> -->
        <form @submit.prevent="handleSignIn" autocomplete="off">
          <div class="mb-3">
            <input v-model="loginData.UserName" type="text" class="form-control text-center" dir="ltr" autocomplete="new-password" placeholder="نام کاربری" />
          </div>
          <div class="mb-3">
            <div id="Box-Input" class="">
              <input class="form-control no-border text-center" :type="ShowPass" v-model="loginData.Pass" name="password" id="PassWord" placeholder="کلمه عبور" />
              <span @click.prevent="ShowPass = 'text'" v-if="ShowPass == 'password'"><i class="fal fa-eye errspan" id="togglePassword" title="نمایش رمز"></i></span>
              <span @click.prevent="ShowPass = 'password'" v-if="ShowPass == 'text'"><i class="fal fa-eye-slash errspan" id="togglePassword" title="عدم نمایش رمز"></i></span>
            </div>
          </div>
          <div class="mb-3 animate__animated animate__fadeInDown" v-if="IsMultipleRoles">
            <small class="text-lable">جهت ورود به سامانه، سمت مورد نظر خودرا انتخاب کنید</small>
            <select class="form-control text-center form-select Pointer required text-center" v-model="loginData.SelectedUserId">
              <option selected disabled :value="null">انتخاب سمت</option>
              <option v-for="(item, key) in ListUserRoleForLogin.roles" :key="key" :value="item.userId">{{ item.roleTitle }}</option>
            </select>
          </div>
          <div class="mb-4">
            <a class="text-decoration-none Pointer" @click.prevent="ForgetPass">فراموشی کلمه عبور؟</a>
          </div>
          <!-- <button type="submit" class="btn btn-primary w-100 mb-3" @click="Login">ورود</button> -->
          <MyButton colorType="primary" size="sm" Width="100" @click="Login">ورود</MyButton>
          
          <p class="text-center mobile-switch mt-3 mb-2">حساب کاربری ندارید؟</p>
          <button type="button" class="btn btn-outline-primary w-100 mobile-switch" @click="isActive = true">ثبت نام</button>
          <div class="mobile-switch" v-if="canInstall">
            <MyButton colorType="dark" size="xs" Width="100" Cls="mt-2" @click="installPWA();HellpIOS=false" outline=""> <i class="fas fa-download ms-3"></i> نصب اپلیکیشن Android </MyButton>
            <MyButton colorType="dark" size="xs" Width="100" Cls="mt-2" @click="HellpIOS=true" outline> <i class="fas fa-download ms-3"></i> نصب اپلیکیشن IOS </MyButton>
            <div class="mt-2 alert alert-warning animate__animated animate__bounce" v-if="HellpIOS">
              <p>برای نصب در آیفون:</p>
              <span class="text-dark">۱. روی دکمه <strong>Share</strong> در پایین مرورگر بزنید.</span>
              <span class="text-dark">۲. گزینه <strong>Add to Home Screen</strong> را انتخاب کنید.</span>
            </div>
          </div>

        </form>
      </div>
      <div class="form-panel sign-in-panel text-center animate__animated animate__fadeIn" v-if="ShowModalForget == true">
        <h4 class="mb-1 fw-bold text-dark">فراموشی رمز عبور</h4>
        <div class="container">
          <div class="row" v-if="IsSendSms == 0">
            <div class="col-12 mb-4">
              <small class="text-dark"> جهت بازیابی رمز ورود باید شماره موبایل و کد ملی خودتو وارد کنی </small>
            </div>
            <div class="col-xl-12 col-12 mt-3">
              <input class="form-control text-center mt-1" placeholder="شماره موبایل" @input="this.$ValidNumber($event, 11)" v-model="ForgetPassModel.Mobile" />
            </div>
            <div class="col-xl-12 col-12 mt-2">
              <input class="form-control text-center mt-1" placeholder="کـد مـلـی" @input="this.$ValidNumber($event, 10)" v-model="ForgetPassModel.CodeMeli" />
            </div>
            <div class="col-12 mt-5">
              <div class="">
                <MyButton colorType="info" size="sm" Width="100" @click="SendCode">ارسال کد یکــبار مصرف</MyButton>
              </div>
              <div class="mt-2">
                <MyButton colorType="primary" size="sm" Width="100" outline @click="ShowModalForget = false"> بازگشت به صفحه ورود <i class="fal fa-arrow-left"></i></MyButton>
              </div>
            </div>
          </div>
          <div class="row animate__animated animate__fadeIn" v-else-if="IsSendSms == 1">
            <div class="col-12 mb-4">
              <small class="text-dark"> حالا کد ارسال شده روی تلفن همراهت رو ارسال کن و در مرحله آخر رمز جدیدتو وارد کن و تمام! </small>
            </div>
            <div class="col-12 mt-3">
              <input type="number" placeholder="کــد پیامک شده" class="form-control DigitCode text-center" v-model="RandomKey" />
            </div>
            <div class="col-12 mt-3">
              <div class=""><MyButton colorType="info" size="sm" Width="100" @click="CheckCode">بررسی </MyButton></div>
              <div class="mt-2">
                <MyButton
                  colorType="primary"
                  size="sm"
                  Width="100"
                  outline
                  @click="
                    ShowModalForget = false;
                    IsSendSms = 0;
                  "
                >
                  بازگشت به صفحه ورود <i class="fal fa-arrow-left"></i
                ></MyButton>
              </div>
            </div>
            <div class="col-12 mt-4">
              <h4></h4>
            </div>
          </div>
          <div class="row animate__animated animate__fadeIn" v-else>
            <div class="col-12 mb-3">
              <small class="text-dark"> در مرحله نهایی فقط کافیه رمز ورود جدیدت و تکرارش باهم همخوانی داشته باشن </small>
            </div>
            <div class="col-xl-12 col-12 mt-3">
              <input class="form-control text-center mt-2" placeholder="رمز عبور جدید" v-model="NewPass" />
            </div>
            <div class="col-xl-12 col-12 mt-1">
              <input class="form-control text-center mt-2" placeholder="تکرار رمز عبور جدید" v-model="ConfirmNewPass" />
            </div>
            <div class="co-12 mt-3">
              <div class="">
                <MyButton colorType="info" size="sm" Width="100" @click="SubChangePass">تغییر رمز</MyButton>
              </div>
              <div class="mt-2">
                <MyButton
                  colorType="primary"
                  size="sm"
                  Width="100"
                  outline
                  @click="
                    ShowModalForget = false;
                    IsSendSms = 0;
                  "
                >
                  بازگشت به صفحه ورود <i class="fal fa-arrow-left"></i
                ></MyButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-panel sign-up-panel text-center">
        <h6 class="mb-4 fw-bold text-success">فقط یک قدم تا عضویت فاصله داری!</h6>
        <!-- <small class="mb-3 text-dark">اطلاعات اولیه رو وارد کن تا نام کاربری و رمز عبورت ایجاد بشه.</small> -->
        <form class="" id="Register">
          <div class="mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.Name" @input="this.$ValidPersian($event, 50)" placeholder="نام" />
          </div>
          <div class="mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.Family" @input="this.$ValidPersian($event, 50)" placeholder="نام خانوادگی" />
          </div>
          <!-- <div class="col-xl-12 col-12 mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.LtName" @input="this.$ValidEngilsh($event, 50)" placeholder="نام لاتین" dir="ltr" />
          </div>
          <div class="col-xl-12 col-12 mb-3">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.LtFamily" @input="this.$ValidEngilsh($event, 50)" placeholder="نام خانوادگی لاتین" dir="ltr" />
          </div> -->
          <div class="mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.CodeMeli" @input="this.$ValidNumber($event, 10)" placeholder="کد ملی" dir="ltr" />
          </div>
          <div class="mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.Mobile" @input="this.$ValidNumber($event, 11, true)" placeholder="شماره موبایل" dir="ltr" />
          </div>
          <div class="mb-1">
            <date-picker
              v-model="RegisterModel.BirthDay"
              input-class="form-control form-control-md text-center required text-center"
              placeholder="تاریخ تولد"
              type="date"
              auto-submit
              color="#6366f1"
            ></date-picker>
          </div>
          <div class="mb-1">
            <select class="form-control text-center form-select Pointer required text-center" v-model="RegisterModel.TblComboCatIdSex">
              <option selected :value="-1">جنسیت</option>
              <option v-for="(item, key) in ListTblComboCatIdSex" :key="key" :value="item.id">{{ item.title }}</option>
            </select>
          </div>
          <div class="mb-1">
            <select class="form-control form-select text-center Pointer required text-center" v-model="RegisterModel.TblComboCatIdMaghtaeTahsili">
              <option selected :value="-1">مقطع تحصیلی</option>
              <option v-for="(item, key) in ListTblComboCatIdMaghtaeTahsili" :key="key" :value="item.id">{{ item.title }}</option>
            </select>
          </div>
          <div class="mb-3">
            <select class="form-control text-center form-select Pointer required text-center" v-model="RegisterModel.TblComboCatIdTaahol">
              <option selected :value="-1">وضعیت تاهل را انتخاب کنید</option>
              <option v-for="(item, key) in ListTblComboCatIdTaahol" :key="key" :value="item.id">{{ item.title }}</option>
            </select>
          </div>
          <!-- <div class="mb-1">
            <input type="text" class="form-control text-center required" v-model="RegisterModel.Email" @input="this.$ValidEngilsh($event, 50)" placeholder="ایمیل" dir="ltr" />
          </div> -->

          <MyButton colorType="success" size="sm" Width="100" @click.prevent="Register">درخواست عضویت</MyButton>

          <p class="text-center mobile-switch mt-3 mb-2">قبلاً ثبت نام کرده‌اید؟</p>
          <button type="button" class="btn btn-outline-success w-100 mobile-switch" @click="isActive = false">ورود</button>
        </form>
      </div>

      <div class="overlay-container">
        <div class="overlay-panel">
          <div class="overlay-content overlay-right">
            <h1 class="fw-bold mb-1 text-light">سلام!</h1>
            <h5 class="fw-bold mb-3 mt-2 text-dark">
              به
              <span class="fw-bold text-light" v-if="CustomerName != null">{{ CustomerName }}</span>
              <div class="spinner-grow text-lable" style="width: 2rem; height: 2rem" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              خوش آمدید
            </h5>
            <img src="../../public/img/icons/pardisLogo.png" v-if="CustomerCode!=0" class="" alt="PardisLearning" width="150"/>
            <img src="../../public/img/icons/Logo_LTwo_New.png" v-else class="" alt="LTwo.ir" width="150"/>
            <!-- <img src="../../public/img/icons/l2 Trancparent.png"  class="" alt="User Avatar" width="150"/> -->
            <p class="mt-3 text-dark">هنوز عضو آموزشگاه نشدی؟ اگه دوست داری تو هم یکی از فراگیرای ما باشی، کافیه روی «ثبت‌نام» کلیک کنی.</p>
            <MyButton colorType="dark" size="sm" Width="" @click="isActive = true" outline>درخواست عضویت و ثبت نام</MyButton>
            <div class="mt-3">
              <small> نسخه : [ {{ Ver }} ] </small>
            </div>
          </div>

          <div class="overlay-content overlay-left">
            <h5 class="fw-bold mb-5 mt-2 text-dark">با <span class="fw-bold text-light">Logic Line</span> یعنی خط مستقیم شما به سوی مدیریت هوشمند</h5>
            <p class="mb-4">اگر قبلاً ثبت نام کرده‌اید یا نام کاربری و رمز عبور دارید، با اطلاعات خود وارد شوید.</p>
            <MyButton
              colorType="dark"
              size="sm"
              Width=""
              @click="
                isActive = false;
                ShowModalForget = false;
                IsSendSms = 0;
              "
              outline
              >ورود به سامانه</MyButton
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "animate.css";
import MyButton from "../components/Button.vue";
import Modal from "../views/component/Modal.vue";
import Swal from "sweetalert2";
import appsetting from "../../public/appSettings.json";
export default {
  components: { MyButton, Modal },
  data() {
    return {
      isActive: false, // مدیریت وضعیت پنل (true برای ثبت‌نام، false برای ورود)
      loginData: {
        UserName: "",
        Pass: "",
        SelectedUserId:null
      },
      registerData: {
        firstName: "",
        lastName: "",
        nationalId: "",
        phone: "",
        email: "",
        address: "",
      },

      RegisterModel: {
        name: "",
        Family: "",
        LtName: "",
        LtFamily: "",
        CodeMeli: "",
        BirthDay: "",
        Mobile: "",
        UserName: "",
        Pass: "",
        Email: "",
        TblComboCatIdMaghtaeTahsili: -1,
        Address: "",
        TblComboCatIdTaahol: -1,
        FatherName: "",
        TblChildId: null,
        phoneHome: "",
        RegisterDate: this.$GetJalaliDateTime(),
        Description: null,
        Sath: null,
        IsActive: true,
        TblAttachmentId: null,
        TblComboCatIdUserRole: 0,
        TblComboCatIdNoeSabteNam: null,
        TblComboCatIdNesbat: null,
        TblComboCatIdSex: -1,
      },
      ListTblComboCatIdSex: [],
      ListTblComboCatIdTaahol: [],
      ListTblComboCatIdMaghtaeTahsili: [],

      ForgetPassModel: {
        CodeMeli: "",
        Mobile: "",
      },
      ShowModalForget: false,
      IsSendSms: 0,
      ShowPass: "password",
      CustomerName: null,
      CustomerCode: 0,
      Ver: "[ 2.0.0 ]",
      deferredPrompt: null, // ذخیره رویداد نصب
      canInstall: false, // وضعیت نمایش دکمه
      HellpIOS: false, 
      IsMultipleRoles:false,
      ListUserRoleForLogin:[]
    };
  },
  methods: {
    handleSignIn() {
      // console.log("ارسال فرم ورود:", this.loginData);
      // متد API خود را اینجا فراخوانی کنید
    },
    handleSignUp() {
      // console.log("ارسال فرم ثبت‌نام:", this.registerData);
      // متد API خود را اینجا فراخوانی کنید
    },
    Login() {
      this.$SweetAlertTost("درحال بررسی اطلاعات", "در حال بررسی اطلاعات وروردی ، لطفا منتظر بمانید ...", "info", null);
      var k = this.$CreateKey(this.loginData);
      this.$PostData("Post", "Auth/Login", k, false).then((result) => {
        this.$CloaseSweetAlert();
        if (result.success == true) {
          // هنگام ورود موفق
          this.$SetCookies("token", result.data.key);
          this.$SetCookies("user", JSON.stringify(result.data.user));

          this.$SaveArrayToCookies(result.data.menu);
          this.$SaveArray(result.data.menu);

          const restoredArray = this.$ReadArrayFromCookies();
          const restoredArray1 = this.$GetArray();
          
          // this.$SetCookies("menus", JSON.stringify(result.data.menu));

          // localStorage.setItem("token", result.data.key);
          // localStorage.setItem("user", JSON.stringify(result.data.user));
          // localStorage.setItem("menus", JSON.stringify(result.data.menu));
          this.$router.push({ name: "Dashbord" });
        } else {
          if (result.message==="MultipleRoles") {
            this.IsMultipleRoles=true
            this.ListUserRoleForLogin=result.data
            // this.$SweetAlert("انتخاب سمت", "با این نام کاربری چند سمت در سیستم ثبت شده است ، لطفا سمتی که میخواهید با آن وارد شوید را انتخاب کنید", "warning", 6000);
          }
          else{
            this.$SweetAlert("عملیات ناموفق", result.message, "error", 3000);
          }
        }
      });
    },
    Register() {
      if (!this.$ValidForm("Register")) {
        return;
      }
      this.$SweetQustion(
        "",
        " تاکنون پیش زمینه ای در یادگیری زبان داشته اید؟ و یا تا کنون در کلاس های زبان شرکت کرده اید ؟",
        "question",
        "بله",
        "خیر",
        null,
        this.RegisterFaragir,
        this.RegisterTaeenSath,
      );
    },
    RegisterTaeenSath() {
      var k = this.$CreateKey(this.RegisterModel);
      this.$PostData("Post", "Auth/Register", k, false).then((result) => {
        if (result.success == true) {
          this.$SweetAlert("عملیات موفق", result.message, "success", 5000);
          this.IsRegister = false;
          this.RegisterModel = {
            name: "",
            Family: "",
            LtName: "",
            LtFamily: "",
            CodeMeli: "",
            BirthDay: "",
            Mobile: "",
            UserName: "",
            Pass: "",
            Email: "",
            TblComboCatIdMaghtaeTahsili: -1,
            Address: "",
            TblComboCatIdTaahol: -1,
            FatherName: "",
            TblChildId: null,
            phoneHome: "",
            RegisterDate: "",
            Description: null,
            Sath: null,
            TblAttachmentId: null,
            TblComboCatIdUserRole: 0,
            TblComboCatIdNoeSabteNam: null,
            TblComboCatIdNesbat: null,
          };
        } else {
          this.$SweetAlert("عملیات ناموفق", result.message, "error", 3000);
        }
      });
    },
    RegisterFaragir() {
      var k = this.$CreateKey(this.RegisterModel);
      this.$PostData("Post", "Auth/RegisterFaragir", k, false).then((result) => {
        if (result.success == true) {
          this.$SweetAlert("عملیات موفق", result.message, "success", 5000);
          this.IsRegister = false;
          this.RegisterModel = {
            name: "",
            Family: "",
            LtName: "",
            LtFamily: "",
            CodeMeli: "",
            BirthDay: "",
            Mobile: "",
            UserName: "",
            Pass: "",
            Email: "",
            TblComboCatIdMaghtaeTahsili: -1,
            Address: "",
            TblComboCatIdTaahol: -1,
            FatherName: "",
            TblChildId: null,
            phoneHome: "",
            RegisterDate: "",
            Description: null,
            Sath: null,
            TblAttachmentId: null,
            TblComboCatIdUserRole: 0,
            TblComboCatIdNoeSabteNam: null,
            TblComboCatIdNesbat: null,
          };
        } else {
          this.$SweetAlert("عملیات ناموفق", result.message, "error", 3000);
        }
      });
    },
    ForgetPass() {
      this.ShowModalForget = true;
    },
    CloseModal() {
      this.ShowModalForget = false;
      this.IsSendSms = 0;
    },
    SendCode() {
      if (this.ForgetPassModel.CodeMeli == "" || this.ForgetPassModel.Mobile == "") {
        this.$SweetAlert("خطا", "وارد کردن کد ملی و شماره موبایل الزامی می باشد", "error", 2000);
        return;
      }
      let k = this.$CreateKey(this.ForgetPassModel);
      this.$PostData("Post", "Users/ForgetPass", k, false).then((res) => {
        if (res.success == true) {
          this.IsSendSms = 1;
          this.$SweetAlertTost("ارسال رمز یکبار مصرف", res.message, "success", 1500);
        } else {
          this.$SweetAlertTost("خطا", res.message, "error", 1500);
        }
      });
    },
    CheckCode() {
      let Model = { CodeMeli: this.ForgetPassModel.CodeMeli, Mobile: this.ForgetPassModel.Mobile, RandomKey: this.RandomKey + "" };
      let k = this.$CreateKey(Model);
      this.$PostData("Post", "Users/CheckRandomKey", k, false).then((res) => {
        if (res.success == true) {
          this.$SweetAlertTost("تعیین رمز جدید", res.message, "success", 1500);
          this.IsSendSms = 2;
        } else {
          this.RandomKey = "";
          this.$SweetAlertTost("خطا", res.message, "error", 1500);
        }
      });
    },
    SubChangePass() {
      // if (this.$ValidPassword(null, this.NewPass, 5, true, true, true) == true) {
      if (this.NewPass == this.ConfirmNewPass) {
        let Model = { CodeMeli: this.ForgetPassModel.CodeMeli, Mobile: this.ForgetPassModel.Mobile, NewPass: this.NewPass };
        let k = this.$CreateKey(Model);
        this.$PostData("Post", "Users/ChangePassLogin", k, false).then((res) => {
          if (res.success == true) {
            this.$SweetAlertTost("عملیات موفق", res.message, "success", 1500);
            this.CloseModal();
          } else {
            this.$SweetAlertTost("خطا", res.message, "error", 2500);
          }
        });
      } else {
        this.$SweetAlert("خطا", "کلمه عبور جدید با تکرار آن برابر نیست", "warning", 2000);
      }
      // }
    },

    GetComboTahsil() {
      this.$PostData("Post", "Combo", 1, false).then((data) => {
        this.ListTblComboCatIdMaghtaeTahsili = data.data;
        // this.RegisterModel.TblComboCatIdMaghtaeTahsili=data.data[0].id
      });
    },
    GetComboSex() {
      this.$PostData("Post", "Combo", 10, false).then((data) => {
        this.ListTblComboCatIdSex = data.data.filter((x) => x.id != 3839);
        // this.RegisterModel.ListTblComboCatIdSex=data.data[0].id
      });
    },
    GetComboTaahol() {
      this.$PostData("Post", "Combo", 3, false).then((data) => {
        this.ListTblComboCatIdTaahol = data.data;
        // this.RegisterModel.TblComboCatIdTaahol=data.data[0].id
      });
    },
    GetCustomer() {
      this.$PostData("Get", "Customer/GetCustomer", null, false).then((res) => {
        if (res.success == true) {
          this.$SetCookies("customer", JSON.stringify(res.data));
          this.CustomerName = res.data.nameOfSchool;
          this.CustomerCode = res.data.customerCode
          this.$SaveArray(this.CustomerCode,"CC")
        } else {
          this.CustomerName = null;
          this.CustomerCode = 0;
        }
      });
    },
    async installPWA() {
      if (!this.deferredPrompt) return;

      // نمایش پنجره نصب به کاربر
      this.deferredPrompt.prompt();

      // منتظر ماندن برای انتخاب کاربر (نصب کرد یا کنسل کرد)
      const { outcome } = await this.deferredPrompt.userChoice;

      if (outcome === "accepted") {
        // console.log('کاربر دکمه نصب را زد');
        this.canInstall = false;
      } else {
        // console.log('کاربر نصب را لغو کرد');
      }

      // رویداد یکبار مصرف است، پس آن را خالی می‌کنیم
      this.deferredPrompt = null;
    },
  },
  mounted() {
    // گوش دادن به رویداد نصب مرورگر
    window.addEventListener("beforeinstallprompt", (e) => {
      // جلوگیری از نمایش بنر پیش‌فرض خود مرورگر
      e.preventDefault();
      // ذخیره رویداد برای استفاده در متد کلیک
      this.deferredPrompt = e;
      // نمایش دکمه نصب به کاربر
      this.canInstall = true;
    });

    // اختیاری: گوش دادن به اتمام نصب
    window.addEventListener("appinstalled", () => {
      // console.log('PWA نصب شد!');
      this.canInstall = false;
      this.deferredPrompt = null;
    });
    this.GetComboTaahol();
    this.GetComboSex();
    this.GetComboTahsil();
  },
  created() {
    // چک کردن اینکه آیا اپلیکیشن در حالت وب‌سایت باز شده است (نه نسخه نصب شده)
    const isInstalled = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

    if (!isInstalled) {
      // اگر کاربر در مرورگر است، تمام سرویس‌ورکرهای ثبت شده را پیدا و حذف کن
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          if (registrations.length === 0) {
            console.log("هیچ سرویس‌ورکری پیدا نشد که پاک شود.");
          }
          for (let registration of registrations) {
            registration.unregister().then((success) => {
              if (success) {
                console.log("سرویس‌ورکر با موفقیت حذف (Unregister) شد.");
                // برای اطمینان از اعمال تغییرات، صفحه را یکبار رفرش کنید
                window.location.reload();
              }
            });
          }
        });
      }
    } else {
      this.canInstall = false;
    }

    this.Ver = appsetting.Ver;

    this.GetCustomer();
  },
};
</script>

<style scoped>
input,
.vpd-day {
  /* background-color: #f8f9fa !important; */
  color: #2d3436 !important;
}
::placeholder {
  color: #808080 !important;
}

/* کپی دقیق استایل‌های ارسالی شما با کمی بهینه‌سازی برای Vue */
.auth-page-body {
  font-family: "IRANSansWeb", "Nahid", sans-serif !important;
  background: linear-gradient(270deg, #2a3c58, #2a3c58);
  background-size: 600% 600%;
  animation: gradientAnimation 15s ease infinite;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: rtl;
  overflow: hidden;
  width: 100%;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.container-wrapper {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  width: 90%;
  max-width: 800px;
  min-height: 500px;
}

.form-panel {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.6s ease-in-out, opacity 0.6s ease-in-out;
  z-index: 2;
}

.sign-in-panel {
  left: 0;
}
.sign-up-panel {
  left: 100%;
  opacity: 0;
  z-index: 1;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}

.overlay-panel {
  /*background: linear-gradient(to right, #344d58, #6b90a1);*/
  background: linear-gradient(to right, #384f7a, #3d64adcb);

  color: #fff;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 200%;
  position: relative;
  right: 0;
  transition: transform 0.6s ease-in-out;
}

.overlay-content {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 40px;
  transition: transform 0.6s ease-in-out;
}

.no-spinners::-webkit-outer-spin-button,
.no-spinners::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinners[type="number"] {
  -moz-appearance: textfield;
}

/* انیمیشن‌های فعال شدن پنل */
.container-wrapper.active .sign-in-panel {
  transform: translateX(-100%);
  opacity: 0;
  pointer-events: none;
}
.container-wrapper.active .sign-up-panel {
  transform: translateX(-100%);
  opacity: 1;
  z-index: 5;
}
.container-wrapper.active .overlay-container {
  transform: translateX(-100%);
}
.container-wrapper.active .overlay-panel {
  transform: translateX(50%);
}

.mobile-switch {
  display: none !important;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .container-wrapper {
    min-height: 600px;
    overflow-y: auto;
  }
  .form-panel {
    width: 100%;
    position: relative;
    opacity: 1;
    transform: none !important;
    left: 0;
    right: 0;
  }
  .overlay-container {
    display: none;
  }
  .sign-up-panel {
    display: none;
  }
  .mobile-switch {
    display: block !important;
  }
  .container-wrapper.active .sign-in-panel {
    display: none;
  }
  .container-wrapper.active .sign-up-panel {
    display: flex;
  }
}

select,
input,
.vpd-input-group {
  background-color: #fff !important;
  color: #2d3436 !important;
  border: 1px solid #cfcfcf !important;
  appearance: none; /* حذف فلش پیش‌فرض برای کنترل بهتر */
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 8px 12px !important;
  cursor: pointer;
}
</style>
<style scoped>
.errspan {
  float: left !important;
  margin-left: 28px !important;
  margin-top: -28px !important;
  cursor: pointer !important;
  position: relative !important;
  z-index: 2 !important;
  color: #6366f1 !important;
}
</style>
